import { Button, Table } from 'antd'
import PopupAfterSale from './PopupAfterSale'
import { useState } from 'react'
import AuthComponent from '../../../components/AuthComponent'
import PopupDetail from './PopupDetail'
import {connect} from "react-redux";
/**
 *
 * @param {Array} list 表格数据
 * @param {String|Number} total 数据总条数
 * @param {Object} page pageIndex:页码 pageSize:页面大小
 * @param {Function} submit 切换页码时的方法
 * @param {Boolean} loading 数据是否加载中
 * @returns
 */
const AfterSaleTable = (
  {
    list,
    total,
    page,
    submit,
    loading,
    orderType,
    rowSelection,
    auditStatus,
    onHandler = () => {}
  } = {}) => {
  const columns = (status)=>{
    const pss =  []
      if(status == 'REJECT'){
        pss.push({
          title: '驳回原因',
          dataIndex: 'rejectCause',
          key: 'rejectCause',
          align: 'center',
        })
      }
    return [
      {
        title: '售后单号',
        dataIndex: 'aftersaleNo',
        key: 'aftersaleNo',
        align: 'center',
      },
      {
        title: '订单号',
        dataIndex: 'orderNo',
        key: 'orderNo',
        align: 'center',
      },
      {
        title: '订单类型',
        dataIndex: 'orderType',
        key: 'orderType',
        align: 'center',
        render: (text) =>
          ((orderType || []).filter((item) => item.code == text)[0] || {}).name ||
          text,
      },
      {
        title: '购买人姓名',
        dataIndex: 'buyerName',
        key: 'buyerName',
        align: 'center',
        render: (text) => text || '-',
      },
      {
        title: '购买人电话',
        dataIndex: 'buyerPhone',
        key: 'buyerPhone',
        align: 'center',
        render: (text) => text || '-',
      },
      {
        title: '所属门店',
        dataIndex: 'storeName',
        key: 'storeName',
        align: 'center',
      },
      {
        title: '售后类型',
        dataIndex: 'aftersaleTypeName',
        key: 'aftersaleTypeName',
        align: 'center',
      },
      {
        title: '售后状态',
        dataIndex: 'aftersaleStatusName',
        key: 'aftersaleStatusName',
        align: 'center',
      },
      {
        title: '支付渠道',
        dataIndex: 'payWayDesc',
        key: 'payWayDesc',
        align: 'center',
      },
      {
        title: '退款金额',
        dataIndex: 'refundAmount',
        key: 'refundAmount',
        align: 'center',
      },
      {
        title: '退款创建时间',
        dataIndex: 'aftersaleTime',
        key: 'aftersaleTime',
        align: 'center',
      },
      {
        title: '退款原因',
        dataIndex: 'aftersaleReason',
        key: 'aftersaleReason',
        align: 'center',
      },
      ...pss,
      {
        title: '操作',
        key: 'action',
        align: 'center',
        fixed: 'right',
        width: 180,
        render: (text, record) => (
          <>
            {auditStatus == 'UN_AUDIT'?
              <>
                <AuthComponent authKey="/after-sale/approve">
                  <Button type="link" onClick={() => onHandler('pass',record)}>通过</Button>
                </AuthComponent>
                <AuthComponent authKey="/after-sale/reject">
                  <Button type="link" onClick={() => onHandler('nopass',record)}>驳回</Button>
                </AuthComponent>
              </> : ''
            }
            <AuthComponent authKey="/after-sale/info/{afterSaleNo}">
              <Button type="link" onClick={() => toAfterSale(record)}>
                售后详情
              </Button>
            </AuthComponent>
          </>
        ),
      },
    ]
  }
  const [showAfterSale, setShowAfterSale] = useState(false)
  const [showOrderDetail, setShowOrderDetail] = useState(false)
  const [detail, setDetail] = useState({})
  const toAfterSale = (info) => {
    setShowAfterSale(true)
    setDetail(info)
  }
  return (
    <>
      <Table
        size="middle"
        loading={loading}
        bordered
        columns={columns(auditStatus)}
        dataSource={list}
        rowKey="aftersaleNo"
        scroll={{ x: 1800 }}
        rowSelection={rowSelection}
        pagination={{
          showQuickJumper: true,
          showSizeChanger: true,
          pageSize: page.pageSize,
          current: page.pageIndex,
          total,
          showTotal: (total) => `当前条件共检索到 ${total} 条信息`,
          onChange: (pageIndex, pageSize) => submit({ pageIndex, pageSize }),
        }}
      />
      <PopupAfterSale
        visible={showAfterSale}
        onClose={() => setShowAfterSale(false)}
        detail={detail}
        toOrderDetail={() => setShowOrderDetail(true)}
      />
      <PopupDetail
        visible={showOrderDetail}
        onClose={() => setShowOrderDetail(false)}
        detail={detail}
      />
    </>
  )
}

export default connect((state) => ({
  orderType: state.order.orderType,
}))(AfterSaleTable)
